import React from 'react';
import { Box, Flex, Skeleton, SkeletonCircle, Stack } from '@chakra-ui/react';

function ProfileSkeleton() {
  return (
    <Box
      className="profile-v2-page profile-v2-skeleton"
      aria-busy="true"
      aria-label="Loading profile"
      w="full"
      maxW="820px"
      mx="auto"
    >
      <Box className="profile-v2-hero" borderRadius="lg" p={6}>
        <Flex align="center" gap={4}>
          <SkeletonCircle size="16" />
          <Stack flex="1" gap={3}>
            <Skeleton height="5" width="42%" borderRadius="md" />
            <Skeleton height="4" width="58%" borderRadius="md" />
            <Skeleton height="2" width="full" borderRadius="full" />
          </Stack>
        </Flex>
      </Box>
      <Flex className="profile-v2-grid" gap={5} direction={{ base: 'column', md: 'row' }}>
        <Skeleton flex="1" minH="220px" borderRadius="lg" />
        <Skeleton flex="1" minH="220px" borderRadius="lg" />
      </Flex>
    </Box>
  );
}

export default ProfileSkeleton;
